export default __webpack_public_path__ + "static/2-85dedd4c47ad52fdc757b0d0b6c47db9.png";